module.exports = __webpack_public_path__ + "static/img/service_content3_img.2bfd0e8.png";